import axios from "axios";
import cookies from 'js-cookie'
// import store from "../store";
// axios.defaults.withCredentials=true;
export const Request = {};
//请求超时时长
const TIMEOUT = 20000;






var request = options =>
{
    options.headers = { ...(options.headers || {}) };
    options.body = { ...(options.body || {}) };


    // if( options.action!=='/art/app/login' && options.action!=='/art/app/register' && options.action!=="/art/app/index/userInfo"){
    //     if(!cookies.get("token")) { 
    //         window.location.hash="#/";
    //         return
    //     }
    // }

    options.headers['token'] = cookies.get('token') || 'null'
    options.headers['Content-Type'] = 'application/json; charset=utf-8'
    //参数格式化 http://f.wenjinguan.com/art/app/index/chapter?chapterid=679&bookid=45
    //http://116.62.224.171:8099
    // if (Object.prototype.toString.call(options.body) === "[object Object]" &&
    //     (options.headers && !options.headers['Content-Type'].match('json'))) {
    // options.body = qs.stringify(options.body);
    // }
    // options.body = qs.stringify(options.body);
    return new Promise((resolve, reject) =>
    {
        axios.request({
            headers: options.headers,
            // url: 'http://f.wenjinguan.com' + options.action,
            // url: 'http://116.62.224.171:8099' + options.action,
            // url: 'http://202.106.125.12' + options.action,
            //url: 'http://110.43.71.81' + options.action,
            url: 'https://ysbk.clcn.net.cn' + options.action,
            //https://ysbk.clcn.net.cn/#/ 

            // url: options.action,
            method: options.method,
            data: options.body,
            params: options.params,
            timeout: TIMEOUT,
            emulateJSON: true,
            withCredentials: true
        })
            .then(response =>
            {
                const { data } = response
                // console.log(data)
                if (Number(data.code) === 508)
                {
                    window.location.hash = "#/";
                    reject(data)
                    return
                }
                // if (parseInt(code) === 1) {
                resolve(data)
                // } else {
                //     reject(data)
                // }
            })
            .catch(e =>
            {
                reject(e)
                throw e;
            });
    })
};
//http请求方式
const http = {};
["get", "post", "put", "delete"].forEach(method =>
{
    http[method] = (
        action,
        params,
        extra = { headers: {}, loadig: false, includeToken: false }
    ) =>
    {
        method = method.toUpperCase();

        if (method === "GET")
        {
            return request({
                action,
                params,
                method,
                headers: extra.headers,
                loading: extra.loading,
                includeToken: extra.includeToken
            });
        }
        return request({
            action,
            body: params,
            method,
            headers: extra.headers,
            loading: extra.loading,
            includeToken: extra.includeToken
        });
    };
});
Request.http = http;



// let baseURLDataval = `${window.location.protocol}//${window.location.host}`
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? baseURLDataval : ''


// Request.baseURLDataval = baseURLDataval; 

